import { DeviceSummaryTable } from "modules/system/sections/plt/field-management/selectors/dialogs/evaluate/DeviceSummaryTable";

import { Stack } from "@bps/fluent-ui";
import { SectionTitle } from "@components/SectionTitle";
import { withPermissions } from "@components/withPermissions";
import { useTenantDevices } from "@libs/api/gateways/field/field-ops-gateway.hooks";
import { Tenant } from "@libs/api/gateways/plt/plt-gateway.dtos";
import { Permissions } from "@libs/permissions/permissions.enum";

interface FieldDevicesTenantPageProps {
  tenant: Tenant;
}

const FieldDevicesTenant = ({ tenant }: FieldDevicesTenantPageProps) => {
  const { id: tenantId } = tenant;

  const { data: tenantDevices, isLoading, error } = useTenantDevices(tenantId);

  return (
    <Stack
      key={tenantId}
      styles={{
        root: {
          paddingLeft: 10,
          paddingRight: 10
        }
      }}
      tokens={{ childrenGap: 8 }}
    >
      <SectionTitle>Tenant Field Devices</SectionTitle>
      <DeviceSummaryTable
        items={tenantDevices ?? []}
        enableShimmer={isLoading}
        errorMessage={error?.message}
        isSelectedOnFocus
      />
    </Stack>
  );
};

export const FieldDevicesTenantPage = withPermissions(
  FieldDevicesTenant,
  [Permissions.PltFieldManagementRead, Permissions.PltFieldManagementWrite],
  "or"
);
